module.exports = __webpack_public_path__ + "static/media/caregiver-mobile-1.ca365dab.png";